import { jsx as m } from "react/jsx-runtime";
import { c as a } from "react/compiler-runtime";
import { CardActions as c } from "@mui/material";
import { forwardRef as n } from "react";
const p = n((s, e) => {
  const o = a(7);
  let r, t;
  o[0] !== s ? ({
    children: r,
    ...t
  } = s, o[0] = s, o[1] = r, o[2] = t) : (r = o[1], t = o[2]);
  let i;
  return o[3] !== r || o[4] !== t || o[5] !== e ? (i = /* @__PURE__ */ m(c, { ref: e, ...t, children: r }), o[3] = r, o[4] = t, o[5] = e, o[6] = i) : i = o[6], i;
});
p.displayName = "CardActions";
export {
  p as CardActions
};
